import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { getSettingEnableDetailedSessionTracing } from "../settings/getSettingEnableDetailedSessionTracing";
import { TelemetryManagerNoOp } from "./TelemetryManagerNoOp";
import { TelemetryManagerOtel } from "./TelemetryManagerOtel";
export var B3_HEADER_SAMPLED = "x-b3-sampled";
export var B3_HEADER_SPAN = "x-b3-spanid";
export var B3_HEADER_TRACE = "x-b3-traceid";
export var DD_HEADER_SAMPLED = "x-datadog-sampling-priority";
export var DD_HEADER_SPAN = "x-datadog-parent-id";
export var DD_HEADER_TRACE = "x-datadog-trace-id";
export var DD_HEADER_ORIGIN = "x-datadog-origin";
export var FAIRE_SPAN_ID_TRACKING = "x-faire-span-id-tracking";
/**
 * TelemetryManager is a singleton class that manages the OpenTelemetry
 * provider and tracer. It provides methods to start and end traces and spans,
 * and to get the headers for the active trace or span.
 * It also provides methods to start, end, and get headers for managed spans.
 * Managed spans are spans that are created by the TelemetryManager
 * and are not directly associated with the current context.
 */ export var TelemetryManager = function TelemetryManager() {
    "use strict";
    _class_call_check(this, TelemetryManager);
};
TelemetryManager.instance = null;
TelemetryManager.get = function() {
    if (!TelemetryManager.instance) {
        if (getSettingEnableDetailedSessionTracing()) {
            TelemetryManager.instance = new TelemetryManagerOtel();
        } else {
            // A no-op implementation of TelemetryManager
            TelemetryManager.instance = new TelemetryManagerNoOp();
        }
    }
    return TelemetryManager.instance;
};
TelemetryManager.reset = function() {
    TelemetryManager.instance = null;
};
